import { CrossSellingPointer } from "../../others";
import { RML } from ".";
/**
 * Attachment details in grid / list view.
 */

const crossRmlAttachmentDetails = () => CrossSellingPointer.waitForVisibleElement("body.wp-admin.upload-php .attachment-info > .details:visible, body.wp-admin.post-php.post-type-attachment #post-body-content #titlewrap:visible", RML, "attachment-details");

export { crossRmlAttachmentDetails };